import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const ReviewsModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "unit-reviews" */
            './'
        )
    ),
    componentName: 'Reviews',
    placeholder: {
        cardType: 'CardType3',
        placeholderType: 'Carousel',
        size: 'lg',
    },
});

export default ReviewsModule;
